import { track, RECEIVE } from '@updater-core/lib/tracker';
import { client } from '../../../helpers/content';

const defaultEntryId = '4CPJ6mMSoEY7UQap30AMLG';
function extractContent({ items = [] }) {
  return items[0] || client.getEntry(defaultEntryId);
}

export function getContent({ fromState, toState }) {
  const sameState = fromState === toState;

  const promises = [
    client
      .getEntries({
        'fields.state[match]': fromState,
        content_type: 'dmvFaq',
      })
      .then(extractContent),
  ];

  if (!sameState) {
    promises.push(
      client
        .getEntries({
          'fields.state[match]': toState,
          content_type: 'dmvFaq',
        })
        .then(extractContent)
    );
  }

  return Promise.all(promises);
}

export function buildAppState({ fromState, toState }, [fromEntry, toEntry]) {
  toEntry = toEntry || fromEntry;
  const fromEntryId = fromEntry.sys.id;
  const toEntryId = toEntry.sys.id;
  const sameState = fromState === toState;

  track({
    verb: RECEIVE,
    object: 'dmv_content',
    details: {
      fromState,
      toState,
      sameState,
      fromIsDefault: fromEntryId === defaultEntryId,
      toIsDefault: toEntryId === defaultEntryId,
      fromEntryId,
      toEntryId,
    },
  });

  const content = {
    from: {
      text: fromEntry.fields.fromState,
      contactInfo: fromEntry.fields.contactInfo,
    },
    to: {
      text: toEntry.fields.toState,
      contactInfo: toEntry.fields.contactInfo,
    },
    within: {
      text: toEntry.fields.withinState,
      contactInfo: toEntry.fields.contactInfo,
    },
  };

  return {
    loading: false,
    content,
    fromState,
    toState,
    sameState,
  };
}
